// test836
(836 && 0);
